<template>
  <b-button-group id="mapheaders" ref="mapheaders" class="map-sub-tier-headers">
    <MapSubTierHeader
      v-for="subtier of subTiers"
      :id="subtier.name"
      :key="subtier.path.toString()"
      :details="subtier"
      data-cy="map-subtier-header"
    />
  </b-button-group>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import MapSubTierHeader from '@/components/public/Visualisations/TheMap/MapSubTierHeaders/MapSubTierHeader.vue'

const components = { MapSubTierHeader }

@Component({ components })
export default class MapSubTierHeaders extends Vue {
  height = 0

  get activeTabTreeNode() {
    return this.$typedStore.activeVisualisation.activeTabTreeNode
  }

  get subTiers() {
    if (this.activeTabTreeNode === false || this.activeTabTreeNode.path.isRoot) return []
    else if ('children' in this.activeTabTreeNode && this.activeTabTreeNode.children) {
      return this.activeTabTreeNode.children
        .slice(0)
        .sort(({ name: a }, { name: b }) => a.localeCompare(b, 'en', { numeric: true }))
    } else return []
  }

  updated() {
    const mapheaders = document.querySelector('#mapheaders')
    if (mapheaders) {
      this.height = mapheaders.getBoundingClientRect().height
    }
  }
}
</script>

<style lang="scss" scoped>
.map-sub-tier-headers {
  position: absolute;
  overflow-x: auto;
  /* active tab CSS rule */
  margin-left: 35px;
  margin-top: 5px;
  z-index: 401;
  max-width: calc(100% - 110px);
  @media (max-width: 932px) {
    margin-left: 15px;
    margin-top: 0;
    max-width: calc(100% - 15px);
    overflow-x: scroll;
  }
  @media (min-width: 933px) {
    &.btn-group > .btn {
      border-radius: 5px;
      &:not(:last-child) {
        margin-right: 5px;
      }
    }
  }
}
</style>
